//
//
//
//
//

import Swiper, { Navigation, Pagination } from "swiper";
import "swiper/swiper.scss";
import "swiper/modules/pagination/pagination.scss";

export const CSS_CLASSES = {
  SWIPER_WRAPPER: "swiper-wrapper",
  SWIPER_NAV_PREV: "swiper-button-prev",
  SWIPER_NAV_NEXT: "swiper-button-next",
  SWIPER_SLIDE: "swiper-slide",
  SWIPER_PAGINATION: "swiper-pagination",
  SWIPER_VISIBLE: "swiper-slide-visible",
  SWIPER_DUPLICATE: "swiper-slide-duplicate"
};

export const SELECTORS = {
  WRAPPER: '[data-carousel="wrapper"]',
  CHEVRON_LEFT: '[data-carousel="chevron-left"]',
  CHEVRON_RIGHT: '[data-carousel="chevron-right"]',
  ITEMS: '[data-carousel="item"]',
  DISABLED_TAB: "[data-disabletab]",
  DOTS: '[data-carousel="dots"]',
  DOT_ELEMENT: "span"
};

export default {
  name: "Carousel",
  props: {
    options: {
      default: () => ({}),
      type: Object
    }
  },
  data() {
    return {
      swiper: {
        type: Object,
        default: undefined
      }
    };
  },
  computed: {
    carouselWrapper() {
      return this.$el.querySelector(SELECTORS.WRAPPER);
    },
    carouselChevrons() {
      return [
        this.$el.querySelector(SELECTORS.CHEVRON_LEFT),
        this.$el.querySelector(SELECTORS.CHEVRON_RIGHT)
      ];
    },
    carouselItems() {
      return this.$el.querySelectorAll(SELECTORS.ITEMS);
    },
    carouselDotContainer() {
      return this.$el.querySelector(SELECTORS.DOTS);
    },
    carouselDots() {
      return this.$el.querySelectorAll(
        `.${CSS_CLASSES.SWIPER_PAGINATION} ${SELECTORS.DOT_ELEMENT}`
      );
    }
  },
  mounted() {
    this.setSwiperClasses();
    const options = this.buildOptions();
    this.swiper = new Swiper(this.$el, options);
    this.bindEvents();
    this.toggleTabItemIndex();
    this.setDotsTabIndex();

    this.swiper.on("slideChange", () => {
      this.toggleTabItemIndex();
    });
  },
  methods: {
    toggleTabItemIndex() {
      /**
       *  Set all carousel slides, duplicates, and their anchor tags to be non-tabbable.
       *  Note: We are using `methods` here instead of `computed` to fetch the updated DOM after carousel's slideChange
       */
      const carouselItems = this.getCarouselItems();
      const duplicateCarouselItems = this.getDuplicateCarouselItems();
      const visibleCarouselItems = this.getVisibleCarouselItems();

      [...carouselItems, ...duplicateCarouselItems].forEach(el => {
        el.tabIndex = "-1";

        const links = el.querySelectorAll("a");
        links.forEach(link => {
          link.tabIndex = "-1";
        });
      });

      /**
       * Set all visible slides and their anchor tags (with no `data-disabletab`) to be tabbable.
       */
      visibleCarouselItems.forEach(el => {
        if (el.firstChild instanceof HTMLAnchorElement) {
          el.firstChild.tabIndex = "0";
        } else {
          el.tabIndex = "0";
        }

        const links = el.querySelectorAll(`a:not(${SELECTORS.DISABLED_TAB})`);
        links.forEach(link => {
          link.tabIndex = "0";
        });
      });
    },
    setDotsTabIndex() {
      this.carouselDots.forEach(dot => {
        dot.tabIndex = "0";
      });
    },
    getCarouselItems() {
      return this.$el.querySelectorAll(SELECTORS.ITEMS);
    },
    getDuplicateCarouselItems() {
      return this.$el.querySelectorAll(
        `.${CSS_CLASSES.SWIPER_DUPLICATE}${SELECTORS.ITEMS}`
      );
    },
    getVisibleCarouselItems() {
      return this.$el.querySelectorAll(
        `.${CSS_CLASSES.SWIPER_VISIBLE}${SELECTORS.ITEMS}:not(${SELECTORS.DISABLED_TAB})`
      );
    },
    setSwiperClasses() {
      const {
        SWIPER_WRAPPER,
        SWIPER_NAV_PREV,
        SWIPER_NAV_NEXT,
        SWIPER_SLIDE,
        SWIPER_PAGINATION
      } = CSS_CLASSES;
      if (this.carouselWrapper)
        this.carouselWrapper.classList.add(SWIPER_WRAPPER);

      this.carouselItems.forEach(carouselItem => {
        carouselItem.classList.add(SWIPER_SLIDE);
      });

      if (this.carouselDotContainer)
        this.carouselDotContainer.classList.add(SWIPER_PAGINATION);

      const [left, right] = this.carouselChevrons;
      if (left) left.classList.add(SWIPER_NAV_PREV);
      if (right) right.classList.add(SWIPER_NAV_NEXT);
    },
    buildOptions() {
      const { options } = this;
      return {
        ...options,
        modules: [Navigation, Pagination]
      };
    },
    bindEvents() {
      const events = ["click"];
      events.forEach(event => {
        this.swiper.on(event, (swiperEvent, nativeEvent) =>
          this.$emit(event, { swiperEvent, nativeEvent })
        );
      });

      this.carouselDots.forEach(dot => {
        dot.addEventListener("keypress", e => {
          if (e.key === "Enter") e.target.click();
        });
      });
    }
  }
};
